module.exports = __webpack_public_path__ + "static/media/book-cluster.642aa3d7.jpg";